document.addEventListener('DOMContentLoaded', () => {
    const tabButtons = document.querySelectorAll('button[data-hunter]');
    const tabSections = document.querySelectorAll('section [data-multi-target]');

    tabSections.forEach(section => {
        section.parentNode.style.display = 'none';
    });

    if (tabButtons.length > 0) {
        const firstButton = tabButtons[0];
        const firstTargetId = firstButton.getAttribute('data-hunter');
        const firstTargetSection = document.querySelector(`section #${firstTargetId}[data-multi-target]`);

        if (firstTargetSection) {
            firstTargetSection.parentNode.style.display = '';
            firstButton.setAttribute('aria-selected', 'true');
            firstButton.classList.add('active');
        }
    }

    tabButtons.forEach(button => {
        button.addEventListener('click', () => {
            const targetId = button.getAttribute('data-hunter');
            const targetSection = document.querySelector(`section #${targetId}[data-multi-target]`);

            if (!targetSection) return;

              tabSections.forEach(section => {
                section.parentNode.style.display = 'none';
            });

            targetSection.parentNode.style.display = '';

            tabButtons.forEach(btn => {
                btn.removeAttribute('aria-selected');
                btn.classList.remove('active');
            });

            button.setAttribute('aria-selected', 'true');
            button.classList.add('active');
        });
    });
});


class ImagesWithTextScrolling extends HTMLElement {
  constructor() {
    super();
    this.contents = [];
    this.images = [];
    this.observer = null;
  }

  connectedCallback() {
    this.contents = this.querySelectorAll(".images-scrolling-desktop__content-list .images-scrolling__content");
    this.images = this.querySelectorAll(".images-scrolling-desktop__media-wrapper > *");

    if (!this.contents.length || !this.images.length) return;

    this.images.forEach((img, i) => {
      img.style.opacity = i === 0 ? "1" : "0";
      img.style.transition = "opacity 0.4s ease";
      img.style.position = i === 0 ? "relative" : "absolute";
    });

    this.observer = new IntersectionObserver(this.onIntersect.bind(this), {
      root: null,
      threshold: 0.5
    });

    this.contents.forEach(content => this.observer.observe(content));
  }

  disconnectedCallback() {
    if (this.observer) {
      this.observer.disconnect();
    }
  }

  onIntersect(entries) {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const index = Array.from(this.contents).indexOf(entry.target);
        this.contents.forEach((c, i) => {
          c.style.opacity = i === index ? "1" : "0";
        });
        this.images.forEach((img, i) => {
          img.style.opacity = i === index ? "1" : "0";
          img.style.position = i === index ? "relative" : "absolute";
        });
      }
    });
  }
}

if (!window.customElements.get("images-with-text-scrolling")) {
  window.customElements.define("images-with-text-scrolling", ImagesWithTextScrolling);
}

// Collection slider
$(document).ready(function(){
  function initSlider() {
    if ($(window).width() < 768) {
      if (!$('.template-list-collections .ic-course-list').hasClass('slick-initialized')) {
        $('.template-list-collections .ic-course-list').slick({
          dots: true,
          arrows: false,
          infinite: false,
          slidesToShow: 2, 
          slidesToScroll: 1,
          adaptiveHeight: true,
          autoplay: true,          // ✅ autoplay enabled
          autoplaySpeed: 3000,     // 3 seconds per slide
          responsive: [
            {
              breakpoint: 540,
              settings: {
                slidesToShow: 1
              }
            }
          ]
        });
      }
    } else {
      if ($('.ic-course-list').hasClass('slick-initialized')) {
        $('.ic-course-list').slick('unslick');
      }
    }
  }

  // Run once on load
  initSlider();

  // Debounced resize handler
  let resizeTimer;
  $(window).on('resize', function(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function(){
      initSlider();
    }, 200);
  });
});

$(document).ready(function(){
  function initSlider() {
    if (!$('.template-collection .ic-course-list').hasClass('slick-initialized')) {
      $('.template-collection .ic-course-list').slick({
        dots: true,
        arrows: false,
        infinite: false,
        slidesToShow: 3,   
        slidesToScroll: 1,
        adaptiveHeight: true,
        autoplay: true,          // autoplay enabled
        autoplaySpeed: 3000,     // 3 seconds per slide
        responsive: [
          {
            breakpoint: 1024,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 768,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 540,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      });
    }
  }

  // Run once on load
  initSlider();
});


  $(document).ready(function () { 
    $(".blog-que h4").on("click", function () { 
      $(".blog-que-content").slideUp(); 
      $(".blog-que h4").removeClass("active"); 
      if (!$(this).next(".blog-que-content").is(":visible")) { 
        $(this).addClass("active"); 
        $(this).next(".blog-que-content").slideDown(); 
      } 
    }); 
  });

$(document).ready(function() {
    var path = window.location.pathname;

    if (path === "/collections/eveboth") {
      $(".day-time-lecture").css('display','none');
      $(".evening-lecture").css('display','block');
    }
    else{
      $(".evening-lecture").css('display','none');
      $(".day-time-lecture").css('display','block');
    }
});
